<template>
  <div class="cart-item-product">
    <CartItemImage :line="line" />

    <div class="description">
      <CartItemTitle :line="line" />
      <CartItemProperties :line="line" />
      <CartItemDetails :line="line" />
      <CartItemRemove :line="line" />
    </div>
  </div>

  <CartItemAddition v-for="addition in additions" :key="addition.key" :line="addition" />
</template>

<script lang="ts" setup>
import { computed } from 'vue'
import { LiquidLineItem } from '../../types/liquid'
import { useCartInject } from '../../context/useCartContext'

import CartItemImage from './CartItemImage.vue'
import CartItemTitle from './CartItemTitle.vue'
import CartItemDetails from './CartItemDetails.vue'
import CartItemProperties from './CartItemProperties.vue'
import CartItemRemove from './CartItemRemove.vue'
import CartItemAddition from './CartItemAddition.vue'

const props = defineProps<{
  line: LiquidLineItem
}>()

const { cart } = useCartInject()

const additions = computed(() =>
  cart.value.items.filter((item) => item.properties?.Product === props.line.product_title)
)
</script>

<style lang="scss">
@import '~styles/base.scss';

.cart-item-product {
  display: grid;
  grid-template-columns: 100px 1fr;
  column-gap: 10px;
  color: var(--color-dark);

  & + & {
    padding-top: 10px;
    margin-top: 10px;
  }

  + .cart-item-addition {
    margin-top: 10px;
  }

  + .cart-item-product {
    margin-top: 20px;
  }

  /* .vendor {
    padding-bottom: 10px;
  }

  .adjustment {
    padding-top: 15px;
  } */
}
</style>
